module.exports = __webpack_public_path__ + "img/Ansicht Leitstand2.483ccb68.jpg";